// extracted by mini-css-extract-plugin
module.exports = {"title":"Collapsible_title__Zwidc","contentWrapper":"Collapsible_contentWrapper__x_BCa","content":"Collapsible_content__cBGAI","container":"Collapsible_container__8NU8i"};